export default {
  localApi: 'https://www.conveniosgboex.com.br/wp-content/themes/bones/server/',
  //localApi: 'https://noz.nu/conveniosgboex/wp-content/themes/bones/server/',
}
